export default __webpack_public_path__ + "static/media/click.c67e4d2a.svg";